import api from '@/api'
import { FilterConditions } from '../types'
export default {
  //읽지않은 메일이 존재하는 폴더 리스트
  getHasUnreadMailFolder():Promise<any> {
    return api.get<any>({
      url: '/IsuMail/ISU_Folder/hasUnreadMail'
    })
  },

  //읽지않음 메일 리스트(메인화면)
  // getUnreadMailList(): Promise<PagedItemList<mail.EmailMessage>> {
  //   return api
  //     .post<PagedItemList<mail.EmailMessage>>({
  //       url: '/api/ews/Dynamic/list?func=getUnreadMailList',
  //       data: {
  //         fields: [
  //           { key: 'Id' },
  //           { key: 'Subject' },
  //           { key: 'IsDraft' }, // 'True' | 'False'
  //           { key: 'IsRead' },
  //           { key: 'Importance' },
  //           { key: 'Preview' },
  //           { key: 'From', format: 'Name' },
  //           { key: 'From', format: 'Address', as: 'Address' },
  //           {
  //             key: 'DateTimeCreated',
  //             format: 'yyyy-MM-dd',
  //             as: 'Date',
  //           },
  //           {
  //             key: 'DateTimeCreated',
  //             format: 'tt h:mm',
  //             as: 'Time',
  //           },
  //           { key: 'HasAttachments' },
  //           { key: 'Categories' },
  //           { key: 'ParentFolderId' },
  //           { key: 'DisplayTo' },
  //         ],
  //         filters: [
  //           {
  //             key: 'IsRead',
  //             value: 'false',
  //             condition: FilterConditions.IsEqualTo,
  //           },
  //         ],
  //         //pageSize: pageOption.size,
  //         //offset: pageOption.offset,
  //         type: 'EmailMessage',
  //       } as mail.api.DynamicApiOptions,
  //     })
  //     .then((items) => {
  //       items.items = items.items.map((item) => ({
  //         ...item,
  //         deleted: false,
  //       }))
  //       return items
  //     })
  // },

  getUnreadMailList(parentId: string, size: number, offset: number): Promise<PagedItemList<mail.EmailMessage>> {
    return api
      .post<PagedItemList<mail.EmailMessage>>({
        url: '/api/ews/Dynamic/list?func=getUnreadMailList',
        data: {
          fields: [
            { key: 'Id' },
            { key: 'Subject' },
            { key: 'IsDraft' }, // 'True' | 'False'
            { key: 'IsRead' },
            { key: 'Importance' },
            { key: 'Preview' },
            { key: 'From', format: 'Name' },
            { key: 'From', format: 'Address', as: 'Address' },
            {
              key: 'DateTimeCreated',
              format: 'yyyy-MM-dd',
              as: 'Date',
            },
            {
              key: 'DateTimeCreated',
              format: 'tt h:mm',
              as: 'Time',
            },
            { key: 'HasAttachments' },
            { key: 'Categories' },
            { key: 'ParentFolderId' },
            { key: 'DisplayTo' },
          ],
          filters: [
            {
              key: 'IsRead',
              value: 'false',
              condition: FilterConditions.IsEqualTo,
            },
          ],
          pageSize: size,
          offset: offset,
          parentId: parentId,
          isIncludeChildSearch: true, //포함 여부 추가 2023-05-26
          type: 'EmailMessage',
        } as mail.api.DynamicApiOptions,
      })
      .then((items) => {
        items.items = items.items.map((item) => ({
          ...item,
          deleted: false,
        }))
        return items
      })
  },

  /**
   * 하나 이상의 아이템을 대상 폴더로 이동합니다.
   * @param ids 아이템 아이디 목록
   * @param destinationFolderId 대상 폴더 아이디
   */
  moveEmails(ids: string[], destinationFolderId: string): Promise<boolean> {
    if (!ids || ids.length === 0) {
      console.error(`ARG_NULL_ERROR: ids is NULL or empty.`)
    }
    if (!destinationFolderId) {
      console.error(`ARG_NULL_ERROR: destinationFolderId is NULL or empty.`)
    }
    return api.post<boolean>({
      url: '/api/ews/EmailMessage/move',
      data: {
        ids,
        destinationFolderId,
      },
    })
  },

  getFiles(code?: string): Promise<appbase.FileInfo[]> {
    if (code) {
        return api.get({
            url: `/file/store/${code}`,
        });
    } else {
        return Promise.resolve([]);
    }
  },
  getSearchPagedList(data: any) : Promise<PagedItemList<mail.EmailMessage>>{
    return api
      .post<PagedItemList<mail.EmailMessage>>({
        url: '/api/ews/Dynamic/list?func=getPagedList',
        data: {
          fields: [
            { key: 'Id' },
            { key: 'Subject' },
            { key: 'IsDraft' }, // 'True' | 'False'
            { key: 'IsRead' },
            { key: 'Importance' },
            { key: 'Preview' },
            { key: 'From', format: 'Name' },
            { key: 'From', format: 'Address', as: 'Address' },
            {
              key: 'DateTimeCreated',
              format: 'yyyy-MM-dd',
              as: 'Date',
            },
            {
              key: 'DateTimeCreated',
              format: 'tt h:mm',
              as: 'Time',
            },
            { key: 'HasAttachments' },
            { key: 'Categories' },
            { key: 'ParentFolderId' },
            { key: 'DisplayTo' },
            ...data.fields,
          ],
          filters: data.filters,
          parentId: data.parentId,
          pageSize: data.pageSize,
          offset: data.offset,
          sorts: data.sorts,
          isIncludeChildSearch: data.isIncludeChildSearch
          ,gubun: 'search'
          ,type: 'EmailMessage'

        } as mail.api.DynamicApiOptions
      })
      .then((items) => {
        //items.parentId = data.parentId
        items.items = items.items.map((item) => ({
          ...item,
          deleted: false,
        }))
        return items
      })
  }
  , getPagedList(data: any): Promise<PagedItemList<mail.EmailMessage>> {
    return api
      .post<PagedItemList<mail.EmailMessage>>({
        url: '/api/ews/Dynamic/list?func=getPagedList',
        data: {
          fields: [
            { key: 'Id' },
            { key: 'Subject' },
            { key: 'IsDraft' }, // 'True' | 'False'
            { key: 'IsRead' },
            { key: 'Importance' },
            { key: 'Preview' },
            { key: 'From', format: 'Name' },
            { key: 'From', format: 'Address', as: 'Address' },
            {
              key: 'DateTimeCreated',
              format: 'yyyy-MM-dd',
              as: 'Date',
            },
            {
              key: 'DateTimeCreated',
              format: 'tt h:mm',
              as: 'Time',
            },
            { key: 'HasAttachments' },
            { key: 'Categories' },
            { key: 'ParentFolderId' },
            { key: 'DisplayTo' },
            ...data.fields,
          ],
          filters: data.filters,
          parentId: data.parentId,
          pageSize: data.pageSize,
          offset: data.offset,
          sorts: data.sorts,
          type: 'EmailMessage',
        } as mail.api.DynamicApiOptions,
      })
      .then((items) => {
        items.parentId = data.parentId
        items.items = items.items.map((item) => ({
          ...item,
          deleted: false,
        }))
        return items
      })
  },
  changeReadState(id: string, read: boolean): Promise<boolean> {
    return api.post<boolean>({
      url: '/api/ews/dynamic/set',
      data: {
        fields: [{ key: 'IsRead', value: read }],
        id: id,
        type: 'EmailMessage',
      } as mail.api.DynamicApiOptions,
    })
  },

  getAttachments(id: string): Promise<mail.EwsAttachment[]> {
    return api
      .post<any>({
        url: '/api/ews/dynamic/get',
        data: {
          fields: [
            { key: 'Id' },
            {
              key: 'Attachments',
              format: 'obj:[id,name,contentType,size,contentId]',
              filters: [
                {
                  key: 'isInline',
                  value: false,
                  operator: 'eq',
                },
              ],
            },
          ],
          itemId: id,
          type: 'EmailMessage',
        },
      })
      .then((res) => {
        return res.item.attachments
      })
  },

  deleteAttachments(id: string, fileIds: string[]): Promise<boolean> {
    return api.delete<boolean>({
      url: '/api/ews/attachment',
      data: {
        itemId: id,
        attachmentIds: fileIds,
      },
    })
  },
  /**
   * 읽음상태를 가져옵니다.
   *
   * @param {string} id 메시지 아이디
   * @returns {Promise<boolean>} 읽음/읽지않음 상태
   */
  getReadState: function(id: string): Promise<boolean> {
    if (!id) {
      throw new Error('ARGUMENT_NULL_EXCEPTION: {id}')
    }
    var data = {
      fields: [{ key: 'IsRead' }],
      itemId: id,
      type: 'EmailMessage',
    }
    return api
      .post<any>({
        url: '/api/ews/Dynamic/get',
        data: data,
      })
      .then(function(res) {
        return res.item
      })
      .then(function(item) {
        return item.isRead === 'True'
      })
  },

  /**
   * 메시지 아이템을 복제 후 임시 폴더에 저장합니다.
   * @param id
   * @param method
   */
  temp(id: string, code: string, method: mail.EmailSendMethods): Promise<string> {
    return api.post<string>({
      url: '/api/ews/emailmessage/temp',
      data: {
        id,
        method,
        code,
      },
    })
  },
  getDetail(id: string): Promise<mail.EmailMessage> {
    return api
      .post<any>({
        url: '/api/ews/dynamic/get',
        data: {
          fields: [
            { key: 'Id' },
            { key: 'Subject' },
            { key: 'IsDraft' },
            { key: 'Categories' },
            { key: 'IsRead' },
            { key: 'Importance' },
            { key: 'AllowedResponseActions', as: 'actions' },
            { key: 'USER_OFFLINE_KEY' },
            { key: 'DateTimeCreated', format: 'yyyy-MM-dd' },
            {
              key: 'DateTimeCreated',
              format: 'yyyy-MM-dd',
              as: 'Date',
            },
            {
              key: 'DateTimeCreated',
              format: 'tt h:mm',
              as: 'Time',
            },
            { key: 'From', format: 'obj:[name,address]' },
            {
              key: 'ToRecipients',
              format: 'obj:[name,address]',
              as: 'to',
            },
            {
              key: 'CcRecipients',
              format: 'obj:[name,address]',
              as: 'cc',
            },
            {
              key: 'BccRecipients',
              format: 'obj:[name,address]',
              as: 'bcc',
            },
            {
              key: 'PidTagLastVerbExecuted',
              as: 'lastVerb',
            },
            {
              key: 'PidTagLastVerbExecutionTime',
              as: 'lastVerbTime',
            },
            {
              key: 'Attachments',
              format: 'obj:[id,name,contentType,size,contentId]',
              filters: [
                {
                  key: 'isInline',
                  value: false,
                  operator: 'eq',
                },
              ],
            },
          ],
          itemId: id,
          type: 'EmailMessage',
        },
      })
      .then((res) => {
        return res.item
      })
  },

  getBody(id: string) {
    if (!id) {
      throw new Error('ARGUMENT_NULL_EXCEPTION: {id}')
    }
    return api
      .get<string[]>({
        url: '/api/ews/body/chunk',
        params: {
          itemId: id,
        },
      })
      .then((results) => {
        return results.map((chunk) => {
          var decodeBase64 = atob(chunk)
          var html = decodeURIComponent(decodeBase64)
          return html
        })
      })
      .then(function(htmls) {
        return htmls.join('')
      })
  },

  setCategories(id: string, categories: string[]): Promise<boolean> {
    var data = {
      fields: [
        {
          key: 'Categories',
          value: categories,
        },
      ],
      id: id,
      type: 'EmailMessage',
    }

    return api.post<boolean>({
      url: '/api/ews/dynamic/set',
      data,
    })
  },
  // delete(id: string): Promise<boolean> {
  //     return api.delete<boolean>({
  //         url: '/api/ews/emailMessage',
  //         data: [id],
  //     });
  // },
  delete(options: mail.api.DeleteRequestData): Promise<boolean> {
    // return api.delete<boolean>({
    //     url: '/api/ews/emailMessage',
    //     data: options,
    // });
    return api.post<boolean>({
      url: '/api/ews/emailMessage/delete',
      data: options,
    })
  },

  send(email: mail.EmailSendRequest) {
    if (!email) {
      throw new Error('ARGUMENT_NULL_EXCEPTION: {email}')
    }
    return api.post<any>({
      url: '/api/ews/EmailMessage',
      data: email,
    })
  },

  getListItem(id: string): Promise<mail.EmailMessage> {
    return api
      .post<any>({
        url: '/api/ews/dynamic/get',
        data: {
          fields: [
            { key: 'Id' },
            {
              key: 'From',
              format: 'obj:[name,address]',
              as: 'from',
            },
            { key: 'Subject' },
            { key: 'IsDraft' }, // 'True' | 'False'
            { key: 'IsRead' },
            { key: 'Importance' },
            {
              key: 'DateTimeCreated',
              format: 'yyyy-MM-dd',
              as: 'Date',
            },
            {
              key: 'DateTimeCreated',
              format: 'tt h:mm',
              as: 'Time',
            },
            { key: 'HasAttachments' },
            { key: 'Categories' },
            { key: 'ParentFolderId' },
            { key: 'DisplayTo' },
          ],
          itemId: id,
          type: 'EmailMessage',
        },
      })
      .then((res) => {
        return res.item
      })
  },
  //문서복호화 파일 저장
  createExportEmailFile(itemId: string, attachmentID: string, cid: string): Promise<number>{
    return api.get<number>({
        url: '/isuMailEws/ISU_Attachment/download',
        params: {
          itemId: itemId,
          attachmentID: attachmentID,
          cid: cid
        }
    })
  },
  //복호화 파일
  getArticleFile(jobId: string): Promise<mail.api.ExportFile> {
    return api.get<mail.api.ExportFile>({
        url: '/File/ISU_File/export',
        params: {
          jobId: jobId
        }
    })
  },
}
